import { defaults, crudAll, ResourceDescriptor, SelectOption } from "./common";
import ldapAuthRenderers from "./ldapAuthRenderers";

const submitOrderTabs = [
    {
        label: "ldap_tab_labels.generic",
        fields: ["directory_type", "host", "port", "use_ssl", "base_dn", "additional_user_dn"],
    },
    {
        label: "ldap_tab_labels.users",
        fields: [
            "username_attribute",
            "given_name_attribute",
            "family_name_attribute",
            "display_name_attribute",
            "locale_attribute",
            "user_email_attribute",
        ],
    },
    {
        label: "ldap_tab_labels.groups",
        fields: ["membership_type", "group_membership_id_attribute", "group_object_filter"],
    },
    {
        label: "ldap_tab_labels.two_factor",
        fields: [
            "enable_two_factor",
            "cert_subject_cn_matching_attribute",
            "cert_subject_alternative_name_matching_attribute",
        ],
    },
];

const submitOrder = [];
for (const i of submitOrderTabs) {
    submitOrder.push(...i.fields);
}

const disableRules = {
    additional_user_dn: (v: any) => v["directory_type"] == "ACTIVEDIRECTORY",
    group_object_filter: (v: any) => v["membership_type"] == "MEMBEROF",
    cert_subject_cn_matching_attribute: (v: any) => !v["enable_two_factor"],
    cert_subject_alternative_name_matching_attribute: (v: any) => !v["enable_two_factor"],
};

const ldap_auth: ResourceDescriptor = {
    url: "ldap_auths",
    orders: {
        list: ["directory_type", "host", "port", "use_ssl", "controlHeaderCell"],
        create: submitOrder,
        update: submitOrder,
    },
    tabbedOrders: {
        create: submitOrderTabs,
        update: submitOrderTabs,
    },
    optionsFormatter: (data: any): SelectOption => {
        return { value: data.id, text: `${data.host}:${data.port}` };
    },
    crudActions: crudAll,
    listDefaults: defaults.list,
    identifiers: ["host", "directory_type"],
    disableRules: {
        create: disableRules,
        update: disableRules,
    },
    renderers: {
        delete: ldapAuthRenderers,
        list: ldapAuthRenderers,
    },
};

export default ldap_auth;
